<ng-container *transloco="let t; prefix: 'filter-property-dropdown'">
<div class="flex flex-col w-full gap-2">

    <!-- Label -->
    @if (labelName !== '') {
    <label [for]="labelName" class="text-gray-950 font-semibold">{{labelName}}
        @if (isRequired) {
            <span class="text-error">*</span>
        }
    </label>
    }
    <!-- Dropdown Toggle -->
    <button
        class="flex justify-between items-center w-full text-left px-4 py-3 border-[1px] rounded-full bg-white text-md text-black"
        [ngClass]="isDropdownOpen ? 'border-primary-600' : 'border-gray-300'"
        (click)="toggleDropdown()">
        {{ selectedDropdownItem?.title || inputPlaceholder }}
        <i [class.rotate-180]="isDropdownOpen"
            [ngClass]="isDropdownOpen ? 'text-primary-600' : 'text-gray-300'"
            class="text-xl font-light text-secondary-900 icon-chevron-up"></i>
    </button>

    <!-- Dropdown Menu -->
    <div *ngIf="isDropdownOpen && dropdownItems.length > 0"
        class="flex flex-col mt-2 w-full bg-white rounded-lg overflow-y-auto"
        [ngClass]="{
            'max-h-40': maxHeightOnDropdownOpen === '40',
            'max-h-52': maxHeightOnDropdownOpen === '52',
            'max-h-80': maxHeightOnDropdownOpen === '80'
          }">
        @for (item of dropdownItems; track $index) {

        <div class="custom-transition hover:bg-gray-100">
            <div class="flex items-start gap-4 py-5 px-5 w-full text-sm text-gray-700 cursor-pointer"
                (click)="selectDropdownItem(item)">
                <!-- Property Photo -->
                <div class="flex">
                    @if (item.defaultPhoto) {
                    <img class="h-[60px] w-[90px] rounded-[2px]"
                        [src]="item.defaultPhoto" alt="Property">
                    } @else {
                    <div
                        class="h-[60px] w-[90px] flex items-center justify-center bg-gray-200 rounded-[2px]">
                    </div>
                    }
                </div>
                <!-- Property Details -->
                <div class="flex flex-1 w-full">
                    <div class="flex flex-col gap-2 w-full">
                        <div class="flex flex-col gap-0.5 w-full">
                            <p class="text-md text-black font-semibold">
                                {{ item.title || 'Untitled' }}
                            </p>
                            @if (item.address && item.address != undefined) {
                            <p class="text-gray-900 text-xs">
                                {{ item.address }}
                            </p>
                            }
                        </div>
                        <div class="flex flex-row w-full gap-2">
                            @if (item.constructionYear) {
                            <span class="text-gray-900 text-xs">
                                {{ item.constructionYear }}
                            </span>
                            <span class="bg-gray-600 rounded-full w-2 h-2 my-auto"></span>
                            }
                            @if (item.floor) {
                              <span class="text-gray-900 text-xs">
                                  {{ item.floor }}{{ t('number-floor') }}
                              </span>
                              <span class="bg-gray-600 rounded-full w-2 h-2 my-auto"></span>
                              }
                            @if (item.bedrooms) {
                              <span class="text-gray-900 text-xs">
                                  {{ item.bedrooms }} {{ item.bedrooms > 1 ? t('bedroom-plural') : t('bedroom')  }}
                              </span>
                              <span class="bg-gray-600 rounded-full w-2 h-2 my-auto"></span>
                              }
                            @if (item.bathrooms) {
                              <span class="text-gray-900 text-xs">
                                  {{ item.bathrooms }} {{ item.bathrooms > 1 ? t('bathroom-plural') : t('bathroom') }}
                              </span>
                              }
                        </div>
                    </div>
                </div>
                <!-- Checkbox -->
                <div class="flex">
                    <label class="custom-radio">
                        <input type="radio" name="option"
                            [checked]="item.checked" />
                        <span class="radio-circle"></span>
                    </label>
                </div>
            </div>
            <!-- Separator -->
            <div class="w-full last:hidden border-b border-gray-200 mx-auto"></div>
        </div>

        }
    </div>
</div>
</ng-container>
